__turbopack_context__.v({
  "className": "noto_sans_hebrew_686f6231-module__LaK-kG__className",
});
